import { cn } from "admin-ui/utils/cn"
import { IconProps } from "."

export default function ShieldStar({
  className,
  transform,
  ...reset
}: Readonly<IconProps>) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("h-6 w-6", className)}
      transform={transform}
      {...reset}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.53314 3.81181C2.25 4.21521 2.25 5.4143 2.25 7.81249V8.99352C2.25 13.2221 5.42922 15.2741 7.42392 16.1455C7.96501 16.3818 8.23556 16.5 9 16.5C9.76444 16.5 10.035 16.3818 10.5761 16.1455C12.5708 15.2741 15.75 13.2221 15.75 8.99352V7.81249C15.75 5.4143 15.75 4.21521 15.4669 3.81181C15.1837 3.4084 14.0563 3.02247 11.8013 2.25059L11.3717 2.10354C10.1963 1.70118 9.60854 1.5 9 1.5C8.39146 1.5 7.80374 1.70118 6.62829 2.10354L6.19868 2.25059C3.94374 3.02247 2.81627 3.4084 2.53314 3.81181ZM8.14595 6.27251L8.04764 6.44887C7.93966 6.64258 7.88567 6.73944 7.80148 6.80334C7.7173 6.86725 7.61246 6.89097 7.40277 6.93841L7.21186 6.98161C6.47396 7.14857 6.10501 7.23205 6.01723 7.51432C5.92945 7.79659 6.18097 8.09072 6.68403 8.67898L6.81418 8.83117C6.95713 8.99833 7.0286 9.08191 7.06076 9.18532C7.09291 9.28872 7.08211 9.40023 7.0605 9.62327L7.04082 9.82632C6.96476 10.6112 6.92674 11.0036 7.15654 11.1781C7.38635 11.3525 7.7318 11.1935 8.4227 10.8754L8.60145 10.7931C8.79778 10.7027 8.89594 10.6575 9 10.6575C9.10406 10.6575 9.20222 10.7027 9.39855 10.7931L9.5773 10.8754C10.2682 11.1935 10.6136 11.3525 10.8435 11.1781C11.0733 11.0036 11.0352 10.6112 10.9592 9.82633L10.9395 9.62327C10.9179 9.40024 10.9071 9.28872 10.9392 9.18532C10.9714 9.08191 11.0429 8.99833 11.1858 8.83117L11.316 8.67898C11.819 8.09072 12.0706 7.79659 11.9828 7.51432C11.895 7.23205 11.526 7.14857 10.7881 6.98161L10.5972 6.93841C10.3875 6.89097 10.2827 6.86725 10.1985 6.80334C10.1143 6.73944 10.0603 6.64258 9.95236 6.44888L9.85405 6.27251C9.47406 5.59084 9.28406 5.25 9 5.25C8.71594 5.25 8.52594 5.59084 8.14595 6.27251Z"
        fill="currentColor"
      />
    </svg>
  )
}
